module.exports = __webpack_public_path__ + "files/cc0d00cc5090502dd2d40e9d389b676c.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Roboto-Slab-regular.woff2
 ** module id = 871
 ** module chunks = 0
 **/